import type { BreakdownView } from "./locationSummaryTypes";

const currencyFormatter = new Intl.NumberFormat(undefined, {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
});

const countFormatter = new Intl.NumberFormat();

export function formatCurrency(value: number | null): string {
  return value === null ? "--" : currencyFormatter.format(value);
}

export function formatWholePercent(numerator: number, denominator: number): string {
  if (denominator === 0) {
    return "--";
  }

  return `${Math.round((numerator / denominator) * 100)}%`;
}

export function formatCount(value: number): string {
  return countFormatter.format(value);
}

export function formatBreakdownValue(value: number, total: number, view: BreakdownView): string {
  return view === "count" ? formatCount(value) : formatWholePercent(value, total);
}
